// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3519":"/chunks/WistiaEmbed","7585":"/chunks/ComponentHomePageBlogPosts","9363":"/chunks/ComponentHomePageWhySuperHosting"}[chunkId] || chunkId) + "." + {"1468":"927a792c606b0592ed01","3519":"cabbd2f7c1097a655660","7585":"ce543d7c74f74af5275f","9363":"cbd26935416a05228085"}[chunkId] + ".js";
};